import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Shield, Lock, Server, Globe, Key, Cpu } from 'lucide-react';
import SEO from '../../components/shared/SEO';

export default function Security() {
    const navigate = useNavigate()
    return (
        <div className="min-h-screen bg-[#050505] text-gray-400 font-sans p-6 md:p-20 relative overflow-hidden">
            <SEO title="Security Protocol" description="Technical deep-dive into EnvDock’s encryption and Zero-Trust access model." />

            {/* Decorative Glow */}
            <div className="absolute top-0 right-0 w-96 h-96 bg-orange-600/5 blur-[120px] rounded-full pointer-events-none" />

            <div className="max-w-5xl mx-auto relative z-10">
                <header className="mb-16">
                    <button onClick={() => navigate(-1)} className="text-[10px] font-black uppercase tracking-[0.3em] text-orange-500 hover:text-orange-400 mb-8 flex items-center gap-2 transition-all group">
                        <span className="group-hover:-translate-x-1 transition-transform">←</span> Return to Core
                    </button>
                    <h1 className="text-4xl md:text-7xl font-black text-white mb-6 tracking-tighter uppercase leading-none">
                        Security <span className="text-orange-500">Protocol</span>
                    </h1>
                    <p className="text-lg text-gray-500 max-w-2xl font-medium">
                        Zero-Knowledge architecture engineered for absolute infrastructure confidentiality.
                    </p>
                </header>

                <div className="grid md:grid-cols-2 gap-6 md:gap-8">
                    <ProtocolCard 
                        icon={Shield} 
                        title="AES-256-GCM" 
                        desc="Application-layer encryption ensures secrets are encrypted before they ever reach our persistent storage layer." 
                    />
                    <ProtocolCard 
                        icon={Globe} 
                        title="TLS 1.3 Strict" 
                        desc="Forced encrypted tunnels for all data egress and ingress, protected against downgrade MITM attacks." 
                    />
                    <ProtocolCard 
                        icon={Key} 
                        title="Isolated Keys" 
                        desc="Unique cryptographic keys per project, managed through a multi-tier master key rotation strategy." 
                    />
                    <ProtocolCard 
                        icon={Cpu} 
                        title="RBAC Logic" 
                        desc="Gated API access via signed JWT tokens and strict Role-Based Access Control on every request." 
                    />
                </div>
            </div>
        </div>
    );
}

const ProtocolCard = ({ icon: Icon, title, desc }) => (
    <div className="p-8 bg-white/[0.02] border border-white/5 rounded-[2.5rem] hover:bg-white/[0.03] hover:border-orange-500/20 transition-all duration-500 group">
        <div className="w-12 h-12 bg-orange-500/10 border border-orange-500/20 rounded-2xl flex items-center justify-center text-orange-500 mb-6 group-hover:scale-110 transition-transform">
            <Icon size={24} />
        </div>
        <h3 className="text-xl font-black text-white uppercase tracking-tight mb-3">{title}</h3>
        <p className="text-sm leading-relaxed text-gray-500 font-medium">{desc}</p>
    </div>
);